// Build WILL FAIL if there are unused imports :(
// import React from 'react';
// import logo from './logo.svg';
import './App.css';

// Import React Router components
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Import testing react components
// An import path can only end with a '.tsx' extension when 'allowImportingTsExtensions' is enabled.
import { Layout } from './components/test_deployment/layout'
import { Home } from './components/test_deployment/home'
import { Contact } from './components/test_deployment/contact'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
